export default __webpack_public_path__ + "static/media/mobile_krush.93edcb4d.png";